import { createFileRoute } from '@tanstack/react-router';
import UpdatePasswordPage from 'src/AkomiLoginPage/ResetPasswordPage/UpdatePasswordPage';

export const Route = createFileRoute('/reset-password/$id')({
  component: UpdatePasswordPage,
});
